import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RolePermissionService } from '@app/shared/services/role-permission/role-permission.service';
import { API_NAME } from '@app/shared/utils/api-util';
import { IUserProfile } from '@layout/models/layout-model';
import { finalize } from 'rxjs';
declare const gigya: any;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  rolePermissionService = inject(RolePermissionService);

  constructor(private readonly http: HttpClient) {}

  getProfileDetails() {
    const profile = localStorage?.getItem('profile') as string;

    try {
      const profileDetails = JSON?.parse(profile);
      return profileDetails as IUserProfile;
    } catch {
      return this.rolePermissionService.getUserProfile();
    }
  }

  setAuthorize(params: any) {
    localStorage.setItem('isAuthorized', params);
  }

  getAuthorize() {
    const authorize =
      (localStorage.getItem('isAuthorized') as string) || 'false';
    try {
      const isAuthorized = JSON?.parse(authorize);
      return isAuthorized as boolean;
    } catch {
      return false as boolean;
    }
  }
  isLoggedIn() {
    const loggedIn = (localStorage.getItem('isLoggedIn') as string) || 'false';
    try {
      const isLoggedIn = JSON?.parse(loggedIn);
      return isLoggedIn as boolean;
    } catch {
      return false as boolean;
    }
  }

  redirectToURL(path: string) {
    globalThis.location.href = globalThis.location.origin + `/${path}`;
  }

  getToken(code: any) {
    return this.http.post(`${API_NAME.get_token}`, {
      code,
      withCredentials: true,
    });
  }

  generateNewToken() {
    return this.http.post(`${API_NAME.generate_new_token}`, null);
  }

  userLogout() {
    return this.http.post(`${API_NAME.user_logout}`, {});
  }

  saveTokens(tokendata: any) {
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem(
      'profile',
      JSON.stringify({
        email: tokendata?.User_Federation_ID,
        firstName: tokendata?.First_Name,
        lastName: tokendata?.Last_Name,
      })
    );
    localStorage.setItem(
      'hashFederation',
      tokendata?.Hashed_User_Federation_ID ?? ''
    );

    localStorage.setItem('country', tokendata.Country);
  }

  getCountry() {
    try {
      return localStorage.getItem('country');
    } catch {
      return '';
    }
  }

  logOut() {
    gigya.accounts.logout({
      callback: (response: any) => {
        if (response.errorCode === 0) {
          this.userLogout()
            .pipe(
              finalize(() => {
                this.clearStorage();
              })
            )
            .subscribe();
        }
      },
    });
  }

  reInitializeCookie() {
    if (document.cookie.includes('_gig_llp')) {
      document.cookie = `_gig_llp=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; domain=.${location?.host}; SameSite=None; Secure;`;
      document.cookie = `_gig_llp=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; domain=.bayer.com; SameSite=None; Secure;`;
    }
  }

  clearStorage() {
    localStorage.clear();
    sessionStorage.clear();
    this.reInitializeCookie();
    this.redirectToURL('');
  }
}
